import { render, staticRenderFns } from "./ChartProfitQuarter.vue?vue&type=template&id=3dd20a6e&scoped=true&"
import script from "./ChartProfitQuarter.vue?vue&type=script&lang=js&"
export * from "./ChartProfitQuarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd20a6e",
  null
  
)

export default component.exports